import { lazyLoad } from "../../../../utils/loadable.js";

export const Affiliates = lazyLoad(
    () => import("./index.js"),
    (module) => module.Affiliates,
);
